class ContentClassificationStore {

  constructor() {
    this.bindActions(this.alt.getActions('ContentClassification'));

    this.contentClassification = '';
    this.classificationsBySource = {
      'app': '',
      'route': '',
      'primaryContentSource': ''
    };
    this.errors = {};
  }

  onUpdateContentClassificationSuccess([classificationSource, contentClassification]) {
    if (classificationSource in this.classificationsBySource){
      this.classificationsBySource[classificationSource] = contentClassification;
      this._updateContentClassification();

      delete this.errors['updateContentClassification'];
    }
  }

  onUpdateContentClassificationFail({ error }) {
    this.errors['updateContentClassification'] = error;
  }

  _updateContentClassification() {
    const { app, route, primaryContentSource } = this.classificationsBySource;
    this.contentClassification = route || primaryContentSource || app;
  }

}

export default ContentClassificationStore;



// WEBPACK FOOTER //
// ./app/flux/stores/ContentClassification.js